import clsx from 'clsx';

interface LoadingDotsProps {
  className?: string;
  fullPage?: boolean;
}

export function LoadingDots({ className, fullPage = false }: LoadingDotsProps) {
  const dotClassName =
    'mx-0.5 size-2 animate-loading-bounce rounded-full bg-primary-500 motion-reduce:animate-none';

  return (
    <div
      className={clsx(
        'flex items-center justify-center p-4',
        fullPage ? 'h-screen w-full' : 'size-full',
        className
      )}
    >
      <div className={clsx(dotClassName, '[animation-delay:-320ms]')} />
      <div className={clsx(dotClassName, '[animation-delay:-160ms]')} />
      <div className={dotClassName} />
    </div>
  );
}
